import { CommonModule } from "@angular/common";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { inject, NgModule, provideAppInitializer } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { Environment, APP_ORIGIN_NAME_TOKEN, NON_PHI_FAX_ORIGIN_TOKEN } from "@kno2/core/configuration";
import { applyBrandTheme, DIALOG_SERVICE_TOKEN, Kno2Lara } from "@kno2/core/theme";
import { BrandsService } from "@kno2/data-access/api-kno2fy-main";
import { SharedThemeModule } from "@kno2/layout";
import { InputMaskModule } from "@ngneat/input-mask";
import { MessageService } from "primeng/api";
import { providePrimeNG } from "primeng/config";
import { DialogService as PDialogService } from "primeng/dynamicdialog";
import { ProgressSpinner } from "primeng/progressspinner";
import { Toast } from "primeng/toast";
import { environment } from "../environments/environment";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { CoreModule } from "./core/core.module";

@NgModule({
    declarations: [AppComponent],
    bootstrap: [AppComponent],
    imports: [
        CoreModule,
        BrowserModule,
        BrowserAnimationsModule,
        CommonModule,
        InputMaskModule,
        AppRoutingModule,
        SharedThemeModule.forRoot(),
        Toast,
        ProgressSpinner
    ],
    providers: [
        MessageService,
        { provide: DIALOG_SERVICE_TOKEN, useClass: PDialogService },
        {
            provide: Environment,
            useValue: new Environment(environment)
        },
        {
            provide: APP_ORIGIN_NAME_TOKEN,
            useValue: `${environment.brand.displayName}-Desktop`.replace(" ", "-")
        },
        {
            provide: NON_PHI_FAX_ORIGIN_TOKEN,
            useValue: `Desktop-${environment.brand.displayName}-Non-Patient`.replace(" ", "-")
        },
        provideHttpClient(withInterceptorsFromDi()),
        provideAppInitializer(() => {
            const brandsService = inject(BrandsService);
            return brandsService.getWebConfiguration().then((config) => applyBrandTheme(config.themes));
        }),
        providePrimeNG({
            theme: {
                preset: Kno2Lara,
                options: {
                    darkModeSelector: false,
                    cssLayer: {
                        name: "primeng",
                        order: "theme, base, primeng, components, utilities"
                    }
                }
            }
        })
    ]
})
export class AppModule {}
